// AuthContext.tsx
import { createContext, useContext, useState } from "react";
import { isUserLoggedIn } from '../../service/auth.service';
import { jwtDecode } from 'jwt-decode';

interface AuthContextType {
  isLoggedIn: boolean;
  setIsLoggedIn: (value: boolean) => void;
  login: (token: string) => void;
  logout: () => void;
  getToken: () => string | null;
  getTokenData: () => any | null;
  isLoggedOrg: (value: string) => boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(() => {
    return isUserLoggedIn();
  });

  const login = (token: string) => {
    localStorage.setItem("token", token);
    const data = getTokenData();
    if(data){
      if(data.roles)
        localStorage.setItem("roles", data.roles);
      if(data.rut)
        localStorage.setItem("rut", data.rut);
      if(data.email)
        localStorage.setItem("email", data.email);
      if(data.organization)
        localStorage.setItem("organization", data.organization);
      if(data.organizations)
        localStorage.setItem("organizations", JSON.stringify(data.organizations));

    }
    setIsLoggedIn(true);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
  };

  const getToken = (): string | null => {
    return localStorage.getItem("token");
  };

  const getTokenData = (): any | null => {
    const token = getToken();
    if (!token) return null;
    try {
      return jwtDecode(token);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };
  const isLoggedOrg = (value: string): boolean => {
    if(value === "ALL") return true;
    const data = getTokenData();
    const organizations: string[] = data?.organizations?.length
      ? data.organizations
      : (data?.organization ? [data.organization] : []);
    if (!organizations.length) return false;
    return organizations.some((org) => value.toUpperCase() === org.toUpperCase());
  }

  return (
    <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, login, logout, getToken, getTokenData, isLoggedOrg }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
};